<template>

    <Head>
        <title>{{ noticia.titulo }}</title>
    </Head>
    <div class="contenido-wrapper contenido-detalle">
        <div class="bloque-general">
            <div class="container">
                <div class="row justify-content-between">

                    <div class="col-lg-8">
                        <div class="breadcrumb-block-wrapper">
                            <ul class="breadcrumb-block">
                                <li class="breadcrumb-block__item">
                                    <Link href="/" class="breadcrumb-block__section">Inicio </Link>
                                </li>
                                <li class="breadcrumb-block__item">
                                    <Link href="/noticias" class="breadcrumb-block__section">Noticias</Link>
                                </li>
                                <li class="breadcrumb-block__item active">
                                    <span class="breadcrumb-block__section">{{ noticia.titulo }}</span>
                                </li>
                            </ul>
                        </div>
                        <div class="hero-simple">
                            <h1 class="hero-simple__titulo" v-html="noticia.titulo"></h1>
                            <span class="hero-simple__fecha">{{ $filters.getFullDate(noticia.created_at) }}</span>
                        </div>
                        <div class="noticia-resumen" v-html="noticia.subtitulo"></div>

                        <Carousel :items-to-show="1" :mouseDrag="false" class="mb-4 inside">
                            <slide v-for="(item, index) in noticia.galeria" :key="(index + 1)">
                                <div class="hero-home-slider__item"
                                    style="width:100%;padding:0 !important; display: inline !important;min-height: auto !important;">
                                    <img :src="item" alt="" />
                                </div>
                            </slide>
                            <template #addons v-if=" noticia.galeria.length > 1">
                                <Navigation />
                                <Pagination />
                            </template>
                        </Carousel>

                        <div class="contenido-administrable" v-html="noticia.contenido"></div>
                    </div>

                    <div class="col-lg-4">
                        <div class="sidebar__wrapper">
                            <BannersBox :banners="banners" />
                            <div class="sidebar__seccion-relacionados">
                                <h4 class="sidebar__titulo">Noticias relacionadas</h4>
                                <NoticiaBox v-for="(item, index) in noticias" :key="index" :item="item"
                                    :truncate="false" />
                            </div>
                            <div class="sidebar__seccion-relacionados">
                                <h4 class="sidebar__titulo">Próximos eventos</h4>
                                <EventoSideBar v-for="(item, index) in eventos" :key="index" :item="item" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import 'vue3-carousel/dist/carousel.css';
import { Link } from '@inertiajs/inertia-vue3'
import NoticiaBox from '../../Shared/Noticias/NoticiaBox.vue'
import BannersBox from '../../Shared/Banners/BannersBox.vue'
import EventoSideBar from '../../Shared/Eventos/EventoSideBar.vue'
import { Carousel, Slide, Navigation, Pagination } from 'vue3-carousel';

export default {
    props: {
        noticia: Object,
        noticias: Object,
        eventos: Object,
        banners: Object,
    },
    components: {
        Link,
        NoticiaBox,
        BannersBox,
        EventoSideBar,
        Carousel,
        Slide,
        Navigation,
        Pagination
    }
}
</script>
<style scoped>
.carousel__pagination{
    padding-left: 0;
}
.noticia-resumen {
    font-size: 1.2rem;
    line-height: 1.4em !important;
    margin-bottom: 10px;
}
</style>
